import { Dispatch, SetStateAction, useState } from 'react';

const useFlag = (initialValue: boolean = false): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [flag, setFlag] = useState<boolean>(initialValue);

  return [flag, setFlag];
};

export default useFlag;
